import Category from '../Category';
import { useEffect, useState } from 'react';
import '../../App.css';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { CategorizedData } from '../../App';
//import categoryTempData from './assets/tempData.json';

// Components
import Loader from '../Loader/Loader';

export interface CatalogData {
  iCourseID: number;
  iFullCourseID: number;
  iSTSReportAreaCategoryID: number;
  iSTSReportAreaID: number;
  mCourseDescription: string;
  sCourseDeliveryTypeAbbrev: string;
  sCourseMinutes: string;
  sCourseName: string;
  sCourseNumber: string;
  sCrossCreditNames: string;
  sCrossCreditNumbers: string;
  sDivisions: string;
  sPreReqNames: string;
  sPreReqNumbers: string;
  sSTSReportAreaCategory: string;
  sSTSReportAreaName: string;
  stsRequirements?: string[] | undefined;
}

axiosRetry(axios, {
  retries: 5,
  retryDelay: (retryCount) => {
    console.log(`Retry attempt #${retryCount}`);
    return retryCount * 2000;
  },
  retryCondition: (error) => {
    const requestData = error.config?.data ? JSON.parse(error.config.data) : {};
    console.error(
      `Request failed with status: ${
        error.response?.status
      }. Retrying... (areaName: ${requestData.areaName || 'N/A'})`
    );
    return (
      error.response?.status === 401 ||
      axiosRetry.isNetworkOrIdempotentRequestError(error)
    );
  },
});

interface AreaNameProps {
  name: string;
}

const AreaName: React.FC<AreaNameProps> = ({ name }) => {
  const [areaName, setAreaName] = useState<string>(name);
  const [catalogData, setCatalogData] = useState<CatalogData[]>([]);
  const [categorizedData, setCategorizedData] = useState<CategorizedData>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const generateSTSRequirements = (catalog: CatalogData) => {
    const divisions = catalog.sDivisions.split('|');
    const requirementsArr: string[] = [];

    divisions.forEach((division) => {
      switch (division.toLowerCase()) {
        case 'buick':
          requirementsArr.push('B');
          break;
        case 'cadillac':
          requirementsArr.push('K');
          break;
        case 'chev ev enrolled (258)':
          requirementsArr.push('C-EV');
          break;
        case 'chevrolet':
          requirementsArr.push('C');
          break;
        case 'gmc':
          requirementsArr.push('G');
          break;
        case 'gmc hummer ev':
          requirementsArr.push('G-EV');
          break;
      }
    });

    return requirementsArr;
  };

  const retrieveCatalogData = async () => {
    setIsLoading(true);
    try {
      const gmAPIResponse = await axios.post(
        '/?rest_route=/gmsts/catalog/areaname',
        { areaName: areaName }
      );
      // This is for local
      // const gmAPIResponse = await axios.post(
      //   'https://catalogbeta.gmstc.com/?rest_route=/gmsts/catalog/areaname',
      //   { areaName: areaName }
      // );
      // console.log(gmAPIResponse);
      if (!gmAPIResponse.data) {
        setIsLoading(false);
        return;
      }
      // console.log(gmAPIResponse.data);
      // hello
      const dataWithSTS = gmAPIResponse.data.map((catalog: CatalogData) => {
        catalog.stsRequirements = generateSTSRequirements(catalog);
        return catalog;
      });
      setCatalogData(dataWithSTS);
      setIsLoading(false);
    } catch (error) {
      console.error('Got an Axios Error', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    retrieveCatalogData();
  }, []);

  useEffect(() => {
    catalogData.forEach((data) => {
      data.stsRequirements = generateSTSRequirements(data);
    });
  }, [catalogData]);

  useEffect(() => {
    // Generate dictionary for
    const categorizedData: {
      [key: string]: {
        [key: string]: Object[];
      };
    } = {};
    catalogData.forEach((course) => {
      // // Extract the AreaCategory
      // const areaCategory: string = course.AreaCategory;

      // // Check if the category already exists in the dictionary
      // if (!categorizedData[areaCategory]) {
      //   // If not, create an array for the category
      //   categorizedData[areaCategory] = [];
      // }

      // // Add the course data to the array under the respective category
      // categorizedData[areaCategory].push(course);

      // Extract the AreaName and AreaCategory
      const areaName: string = course.sSTSReportAreaName.trim();
      const areaCategory: string = course.sSTSReportAreaCategory;

      // Check if the areaName exists in the dictionary
      if (!categorizedData[areaName]) {
        // If not, create a dictionary for the areaName
        categorizedData[areaName] = {};
      }

      // Check if the areaCategory exists in the inner dictionary
      if (!categorizedData[areaName][areaCategory]) {
        // If not, create an array for the areaCategory
        categorizedData[areaName][areaCategory] = [];
      }

      // Add the course data to the array under the respective category
      categorizedData[areaName][areaCategory].push(course);
    });
    setCategorizedData(categorizedData);
  }, [catalogData]);

  // useEffect(() => {
  //   // Generate dictionary for
  //   const categorizedData: {
  //     [key: string]: {
  //       [key: string]: Object[];
  //     };
  //   } = {};
  //   (categoryTempData as []).forEach((course: any) => {
  //     // // Extract the AreaCategory
  //     // const areaCategory: string = course.AreaCategory;

  //     // // Check if the category already exists in the dictionary
  //     // if (!categorizedData[areaCategory]) {
  //     //   // If not, create an array for the category
  //     //   categorizedData[areaCategory] = [];
  //     // }

  //     // // Add the course data to the array under the respective category
  //     // categorizedData[areaCategory].push(course);

  //     // Extract the AreaName and AreaCategory
  //     const areaName: string = course.sSTSReportAreaName;
  //     const areaCategory: string = course.sSTSReportAreaCategory;

  //     // Check if the areaName exists in the dictionary
  //     if (!categorizedData[areaName]) {
  //       // If not, create a dictionary for the areaName
  //       categorizedData[areaName] = {};
  //     }

  //     // Check if the areaCategory exists in the inner dictionary
  //     if (!categorizedData[areaName][areaCategory]) {
  //       // If not, create an array for the areaCategory
  //       categorizedData[areaName][areaCategory] = [];
  //     }

  //     // Add the course data to the array under the respective category
  //     categorizedData[areaName][areaCategory].push(course);
  //   });
  //   setCategorizedData(categorizedData);
  // }, [categoryTempData]);

  const generateId = () => {
    return areaName.toLowerCase().replace(/ /g, '_');
  };

  return (
    <div className='App'>
      <h2 className='areaname-title' id={generateId()}>
        {areaName === 'Fundamentals - Tech Apprentice (Display Only)'
          ? 'Fundamentals (Tech Apprentice)'
          : areaName}
      </h2>
      {isLoading ? (
        <div className='loader-container'>
          <Loader />
        </div>
      ) : (
        <Category categoryData={categorizedData} areaName={areaName} />
      )}
    </div>
  );
};

export default AreaName;
